import './base'
import { createElement } from 'react'
import { ProjectsPage } from 'src/discover'
import { renderWithLocale } from 'src/shared'

document.addEventListener('DOMContentLoaded', () => {
  const pageMountpoint = document.getElementById('page-mountpoint')
  if (pageMountpoint) {
    const data = pageMountpoint.getAttribute('data-json')!
    const page = createElement(ProjectsPage, JSON.parse(data))
    renderWithLocale(page, pageMountpoint)
  }
})
